import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSlidesTall: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="slides-tall"><path fillRule="evenodd" clipRule="evenodd" d="M7.75 2C5.67893 2 4 3.67893 4 5.75V14.25C4 16.3211 5.67893 18 7.75 18H8V18.25C8 20.3211 9.67893 22 11.75 22H16.25C18.3211 22 20 20.3211 20 18.25V9.75C20 7.67893 18.3211 6 16.25 6H16V5.75C16 3.67893 14.3211 2 12.25 2H7.75ZM11.75 6H14.5V5.75C14.5 4.50736 13.4926 3.5 12.25 3.5H7.75C6.50736 3.5 5.5 4.50736 5.5 5.75V14.25C5.5 15.4926 6.50736 16.5 7.75 16.5H8V9.75C8 7.67893 9.67893 6 11.75 6Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSlidesTall;
